/** @format */

import Moment from 'moment';
import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';

import Loading from '../Loading';
import ResetState from '../ResetState';
import Booking from '../Booking/Booking';

function Result({
	match: {
		params: { guid },
	},
}) {
	const [t] = useTranslation('translation');

	const data = useStoreState((state) => state.result);
	const service = useStoreActions((actions) => actions.result);
	const userlanguage = useStoreState((state) => state.user.language);

	Moment.locale(userlanguage);

	useEffect(() => {
		if (data.Booking === null) {
			service.fetchBooking(guid);
		} else {
			window.history.replaceState({}, document.title, '/');
		}
		//eslint-disable-next-line
	}, []);

	return (
		<div>
			<section></section>
			<section></section>
			{data.Booking !== null && (
				<section>
					<h1>{t('haveANiceTrip')}</h1>
					<div className={'verticalSpace28'} />
					<h3>{t('yourOrderRef')}</h3>
					<h3>
						<b>{data.Booking.bookingId}</b>
					</h3>
					<div className={'verticalSpace28'} />
					<Booking booking={data.Booking} />
					<div className={'verticalSpace36'} />
					<h3>
						<ResetState>
							<Link to='/'>{t('goBackAndCreateNewReservation')}</Link>
						</ResetState>
					</h3>
				</section>
			)}

			{data.Booking === null && data.error === null && (
				<section style={{ paddingTop: '22rem' }}>
					<h1>{t('pleaseWait')}</h1>
					<h2>Ingen booking data</h2>
					<Loading />
				</section>
			)}
		</div>
	);
}

export default Result;
